import axios from 'axios';
import config from '@api/config';
import {
    util,
    lg
} from 'utils';
let base = util.getDomain();
let base2 = util.getDomain2();
let $http = {};

$http.get = function (url, params) {
    return axios.get(`${base}/${url}`, {
        params: params
    });
};

$http.getV2 = function (url, params) {
    return axios.get(`${url}`, {
        params: params
    });
};

$http.post = function (url, params) {
    return axios.post(`${base}/${url}`, params, config);
};
$http.post2 = function (url, params) {
    return axios.post(`${base2}/${url}`, params, config);
};
export default $http;

export const MAP_LIST = {
    //隶属项目
    SUBJECT: [{
        Id: '1',
        Name: '美师优教'
    }, {
        Id: '2',
        Name: 'HI幼教'
    }],
    //意向项目
    INTENT_PROJECT: [{
        id: 1,
        name: "美师优教"
    }, {
        id: 2,
        name: "HI幼教"
    }, {
        id: 4,
        name: "智趣坞"
    }],
    STOCKTYPE_NAME: [{
        id: 1,
        name: "仓库"
    }, {
        id: 2,
        name: "资源包"
    }, {
        id: 1024,
        name: "海信"
    }],
    // AB政策
    POLICILY_TYPE: [{
        id: '',
        name: '全部'
    }, {
        id: 1,
        name: "hi幼教A政策"
    }, {
        id: 2,
        name: "hi幼教B政策"
    }],
    // INTENT_LEVEL: [{ id: '', name: '全部' },{ id: 1, name: "A" }, { id: 2, name: "B" }, { id: 3, name: "C" }, { id: 4, name: "D" }],
    IS_OFF: [{
        id: '',
        name: '全部'
    }, {
        id: 1,
        name: "是"
    }, {
        id: 0,
        name: "否"
    }],
    //检测进度类型
    PROGRESS_TYPE: [{
        id: 1,
        name: '设备安装'
    }, {
        id: 2,
        name: '网络检测'
    }]

};


// WEBPACK FOOTER //
// ./src/common/js/http.js